import type { WebModule } from "../../core/modules";
import { CrmPipeline } from "./routes/pipeline";
import { CrmAgenda } from "./routes/agenda";
import { CrmRevenues } from "./routes/revenues";
import { CrmAccount } from "./routes/account";
import { CrmHomeWidget } from "./components/home-widget";

// CRM : pipeline des dossiers, agenda des suivis et rendez-vous, revenus et
// commissions. Outil interne : tout est réservé aux administrateurs.
const crm: WebModule = {
  name: "crm",
  routes: [
    { path: "/crm", element: <CrmPipeline />, adminOnly: true },
    { path: "/crm/agenda", element: <CrmAgenda />, adminOnly: true },
    { path: "/crm/revenus", element: <CrmRevenues />, adminOnly: true },
    { path: "/crm/dossiers/:accountId", element: <CrmAccount />, adminOnly: true },
  ],
  nav: [
    {
      title: "CRM",
      adminOnly: true,
      items: [
        { to: "/crm", label: "Pipeline", icon: "kanban", end: true },
        { to: "/crm/agenda", label: "Suivis & RDV", icon: "checklist", end: true },
        { to: "/crm/revenus", label: "Revenus", icon: "coins", end: true },
      ],
    },
  ],
  homeWidgets: [{ id: "crm-stats", element: <CrmHomeWidget />, adminOnly: true }],
};

export default crm;
